import { BreadCrumb } from "@/components/header/breadcrumb.tsx";
import { useMenuLabel } from "@/hooks/use-menu-label.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile.ts";
import { MobileMenuSidebar } from "@/components/sidebar/mobile-menu-sidebar.tsx";
import { LogoutCombobox } from "@/components/combobox/logout-combobox.tsx";
import { useAuthStore } from "@/stores/use-auth-store.ts";
import { useLogout } from "@/apis/auth.ts";
import { useHeaderStore } from "@/stores/use-header-store.ts";
import { ChevronLeft } from "lucide-react";

export const Header = () => {
  const location = useLocation();
  const current = location.pathname;
  const menuLabel = useMenuLabel(current);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const { mutate: logout } = useLogout();
  const userId = useAuthStore((state) => state.userId);
  const custom = useHeaderStore((state) => state.custom);

  const showCustomHeader = isMobile && custom !== null;

  return (
    <div className='sticky top-0 z-10 flex items-center justify-between pl-4 py-4 md:px-10 md:py-8 bg-white'>
      {showCustomHeader ? (
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 w-full">
            {custom.showBackButton && (
              <button type="button" onClick={() => navigate(-1)} className="p-1 -ml-1">
                <ChevronLeft className="h-5 w-5 text-grayscale-70" />
              </button>
            )}
            <span className="text-sm font-semibold text-grayscale-100 truncate">{custom.title}</span>
          </div>
          <MobileMenuSidebar />
        </div>
      ) : (
        <>
          <BreadCrumb current={menuLabel.currentLabel} parent={menuLabel.parentLabel} grandParent={menuLabel.grandParentLabel} />
          {!isMobile && <LogoutCombobox userId={userId || ''} label="로그아웃" onLogout={logout} />}
          {isMobile && <MobileMenuSidebar />}
        </>
      )}
    </div>
  )
}